import { render, staticRenderFns } from "./Datatables.vue?vue&type=template&id=d7771aca&scoped=true&"
import script from "./Datatables.vue?vue&type=script&lang=js&"
export * from "./Datatables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7771aca",
  null
  
)

export default component.exports